// 3D cart drawer js start 18 July 2024 
window.addEventListener("Angle3DAddToCart", function(event) {
  //$('#cart-drawer').toggle();
  // $('#cart-drawer').attr('active','');
 //$('#cart-drawer').toggleAttr('open');
            var getValues = ('Angle3DAddToCart' + 
            JSON.stringify(event.detail));
            console.log('getValues'+getValues);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
   }));
  document.querySelector("[aria-controls='cart-drawer']").click();
  return false;
   
});

window.addEventListener("Angle3DCustomizerLoaded", function(event) {
            $('#tda-customizer-customization-option-value-container-b94df9-kl5i9u input[type="text"] ,#tda-customizer-customization-option-value-container-i9x6v-rrbmh4 input[type="text"] ,div#tda-customizer-customization-option-value-container-bmbwop-vy0en2 input[type="text"] ,div#tda-customizer-customization-option-value-container-xxxgk4-0uhiap input[type="text"] ,div#tda-customizer-customization-option-value-container-9p1kbp-fmntvp input[type="text"] ,div#tda-customizer-customization-option-value-container-tk04yr-z43uhg input[type="text"], div#tda-customizer-customization-option-value-container-g7ktga-9rac2r input[type="text"], div#tda-customizer-customization-option-value-lnt5p input[type="text"], div#tda-customizer-customization-option-value-rhzfnn input[type="text"], div#tda-customizer-customization-option-value-364po input[type="text"], div#tda-customizer-customization-option-value-kux9fh input[type="text"]').keyup(function() { 
                this.value = this.value.toLocaleUpperCase(); 
            }); 
  
});
// 3D cart drawer js end 18 July 2024 
  document.addEventListener('DOMContentLoaded', function() {
var removeInterval = setInterval(function () {
        var target = $("body.template-product.template-3d-configurator div#rbr-container-element-fbt");

        if (target.length > 0) {
            target.remove(); 
            clearInterval(removeInterval); 
            console.log("rbr-container-element-fbt removed from DOM.");
        }
    }, 1000); 

 $("body").on("click", ".tda-customizer-select-button-customization-option-value-list .tda-customizer-select-button-customization-option-value:first-child .tda-customizer-customization-option-value-title", function() {
    // Clear the value of the input
    $(this).parents(".tda-accordion-panel").find(".tda-customizer-customization-option-value-selected input").val('');
   // $('.tda-customizer-customization-options-container .tda-customizer-customization-option-value-selected input').val('');
});

$("body").on("click", "#tda-customizer-customization-option-value-x6iqx .tda-customizer-customization-option-value-title", function() {
$(".tda-file-upload-content").find(".tda-remove-image").trigger("click");
});

    $(".tda-customizer-variant-price-container").after($(".custom-3D-product-desc-jtpl").html());
        $(".tda-customizer-footer-right").prepend(`<div class="tda-customizer-tax-included production-title-jtpl"> Production takes approximately 6 to 8 weeks, and the item will be dispatched directly from Thailand.<br>
            Wholesale discounts are available for gyms and clubs.<br></div>`);

 });


$(document).ready(function() {

  $("body").on("click","#tda-customizer-customization-option-value-uk8iln,#tda-customizer-customization-option-value-hz6dg9,.tda-customizer-customization-options-container button.tda-accordion",function(){
    //alert("hai");
      $('#tda-customizer-section-btn-25161450782786-jjc36uspan').eq(0).addClass('yokkao-font-text-jtpl');
    var checkElement = setInterval(function() {
        if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-25161450782786-jjc36u').length) {
            $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-25161450782786-jjc36u').addClass('tda-accordion-active');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-25161450782786-jjc36u').addClass('overflow-visible');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-25161450782786-jjc36u').css({
                'max-height': 'min-content',
                'padding': '20px'
            });
            clearInterval(checkElement);
        }
    }, 100);
     
  });
$(document).click(function(event) {
    if (!$(event.target).is('#tda-customizer-customization-option-value-uk8iln,#tda-customizer-customization-option-value-hz6dg9')) {
        $('#tda-customizer-section-btn-25161450782786-jjc36u span').eq(0).removeClass('yokkao-font-text-jtpl');
    }
   
});

// Use js for custom heavy bag start
    $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-81t7zu",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-ldwh5s, span.add-img-with-add-text-jtpl').css('display','none');
      });
        $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-81jwlo",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-ldwh5s, span.add-img-with-add-text-jtpl').css('display','block');
      });
      $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-f1dppl",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-4mvw41, span.add-img-with-add-text-jtpl').css('display','none');
      });
        $("body").on("click",".tda-customizer-customization-option-value-list div#tda-customizer-customization-option-value-x6iqx",function(){
       $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-4mvw41, span.add-img-with-add-text-jtpl').css('display','block');
      });
      jQuery("body").on("change", "#tda-customizer-customization-option-dropdown-5un797", function() {
    if (jQuery("#tda-customizer-customization-option-value-81t7zu").hasClass("tda-customizer-customization-option-value-selected")) {
      $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-ldwh5s, span.add-img-with-add-text-jtpl').css('display','none');
    }
      if (jQuery("#tda-customizer-customization-option-value-f1dppl").hasClass("tda-customizer-customization-option-value-selected")) {
      $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25490307940418-4mvw41, span.add-img-with-add-text-jtpl').css('display','none');
    }
  });
  // Use js for custom heavy bag end

    var checkElement = setInterval(function() {
        if ($('.tda-customizer-customization-options-container button#tda-customizer-section-btn-25161450782786-jjc36u').length) {
            $('.tda-customizer-customization-options-container button#tda-customizer-section-btn-25161450782786-jjc36u').addClass('tda-accordion-active');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-25161450782786-jjc36u').addClass('overflow-visible');
            $('.tda-customizer-customization-options-container div#tda-customizer-section-panel-25161450782786-jjc36u').css({
                'max-height': 'min-content',
                'padding': '20px'
            });
            clearInterval(checkElement);
        }
    }, 100);

   $("body").on("click","#tda-customizer-section-btn-25161450782786-k6defe, #tda-customizer-section-btn-25161450782786-v7wjn, #tda-customizer-section-btn-25161450782786-b3lf7",function(){
  if($("#tda-customizer-customization-option-value-hz6dg9").hasClass("tda-customizer-customization-option-value-selected") || $("#tda-customizer-customization-option-value-uk8iln").hasClass("tda-customizer-customization-option-value-selected")){
                  setTimeout(function() {
      $('#tda-customizer-section-btn-25161450782786-jjc36u span').eq(0).addClass('yokkao-font-text-jtpl');
                  },400);
  } else {
   
      $('#tda-customizer-section-btn-25161450782786-jjc36u span').eq(0).removeClass('yokkao-font-text-jtpl');
  }
});

// Use js for custom heavy bag start
    $('.tda-customizer-customization-options-container #tda-customizer-section-panel-25490307940418-4mvw41')
        .after('<span class="add-img-with-add-text-jtpl">OR</span>');
    
    // If you want to check periodically, use setInterval
    var intervalId = setInterval(function() {
        // Check if the button exists
        if ($('.tda-customizer-customization-options-container #tda-customizer-section-panel-25490307940418-4mvw41').length) {
            // Add the span only once
            if (!$('.add-img-with-add-text-jtpl').length) {
                $('.tda-customizer-customization-options-container #tda-customizer-section-panel-25490307940418-4mvw41')
                    .after('<span class="add-img-with-add-text-jtpl">OR</span>');
            }
            // Optionally, clear the interval once done
            clearInterval(intervalId);
        }
    }, 1000);  
  // Use js for custom heavy bag end

    // Use js for custom Freestyle Kicking Pads start

function updateCustomizerUI() {
  if ($('#tda-customizer-customization-option-value-qhhpf').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25658239221826-5wywr7, span.add-img-with-add-text-jtpl').css('display', 'none');
  }
  if ($('#tda-customizer-customization-option-value-r5v77z').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25658239221826-5wywr7, span.add-img-with-add-text-jtpl').css('display', 'block');
  }

  if ($('#tda-customizer-customization-option-value-jcyfma').hasClass('tda-customizer-customization-option-value-selected')) {
    $('.tda-customizer-customization-options-container .tda-customizer-section-btn-25658239221826-kpwuik, span.add-img-with-add-text-jtpl').css('display', 'none');
  }
}
$('body').on('click', '.tda-customizer-customization-option-value-list > div', function () {
  setTimeout(updateCustomizerUI, 50);
});
  // Use js for custom Freestyle Kicking Pads end

});